/**
 * Resolves the signed-in user’s display label for CMM notes (`poc` in Firestore).
 */
import { generateFullName } from "../../../utils/generateOrderDataForTable";
import { capitalizeString } from "../../../utils/stringModifications";

/**
 * Returns profile full name when `providerDetails` has names; otherwise email, then user id.
 *
 * @param providerDetails - Redux `providerDetails.data` (may be null before fetch completes).
 * @param userEmail - Firebase / Redux user email.
 * @param userId - Firebase / Redux user id.
 * @returns Non-empty label when any input is present; otherwise empty string.
 */
export function getLoggedInUserDisplayNameForNotes(
  providerDetails: { FirstName?: string; LastName?: string } | null | undefined,
  userEmail: string | null | undefined,
  userId: string | null | undefined,
): string {
  const first = providerDetails?.FirstName?.trim() ?? "";
  const last = providerDetails?.LastName?.trim() ?? "";
  const fullName = capitalizeString(generateFullName(first, "", last)).trim();
  if (fullName) return fullName;
  return userEmail?.trim() || userId?.trim() || "";
}
